/* global axios */
import ApiClient from './ApiClient';

class AudienceListsAPI extends ApiClient {
  constructor() {
    super('audience_lists', { accountScoped: true });
  }

  // Parses an uploaded file without persisting anything so the operator can
  // confirm the column mapping against real rows before importing.
  previewFile(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(`${this.url}/preview`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // How many data-registry people the current filters would bring in, split
  // into "reachable" (has a phone or e-mail) and the unfiltered total, so the
  // operator confirms a real number instead of importing blind.
  registryPreview(filters = {}) {
    return axios.get(`${this.url}/registry_preview`, { params: filters });
  }

  candidatePreview({ filters = {}, selectionLimit } = {}) {
    return axios.get(`${this.url}/candidate_preview`, {
      params: {
        ...filters,
        ...(selectionLimit ? { selection_limit: selectionLimit } : {}),
      },
    });
  }

  candidateFilterOptions() {
    return axios.get(`${this.url}/candidate_filter_options`);
  }

  // No file: the rows come from the registry, so this is a plain JSON post
  // rather than the multipart upload createImport uses.
  createRegistryImport(id, { filters = {}, defaultCountryCode } = {}) {
    return axios.post(`${this.url}/${id}/imports`, {
      source_kind: 'data_registry',
      ...filters,
      ...(defaultCountryCode
        ? { default_country_code: defaultCountryCode }
        : {}),
    });
  }

  createCandidateImport(
    id,
    { filters = {}, selectionLimit, defaultCountryCode } = {}
  ) {
    return axios.post(`${this.url}/${id}/imports`, {
      source_kind: 'interview_candidates',
      ...filters,
      ...(selectionLimit ? { selection_limit: selectionLimit } : {}),
      ...(defaultCountryCode
        ? { default_country_code: defaultCountryCode }
        : {}),
    });
  }

  members(id, { page = 1, perPage = 25, status = null, query = null } = {}) {
    return axios.get(`${this.url}/${id}/members`, {
      params: {
        page,
        per_page: perPage,
        ...(status ? { status } : {}),
        ...(query ? { query } : {}),
      },
    });
  }

  imports(id) {
    return axios.get(`${this.url}/${id}/imports`);
  }

  importStatus(id, importId) {
    return axios.get(`${this.url}/${id}/imports/${importId}`);
  }

  createImport(id, { file, columnMapping, defaultCountryCode }) {
    const formData = new FormData();
    formData.append('import_file', file);
    formData.append('column_mapping', JSON.stringify(columnMapping ?? {}));
    if (defaultCountryCode) {
      formData.append('default_country_code', defaultCountryCode);
    }
    return axios.post(`${this.url}/${id}/imports`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new AudienceListsAPI();
